// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"8330c046","36":"cb36526a","145":"f3247700","267":"f2d06dfb","640":"658e685f"}[chunkId] + ".chunk.css";
};